import { render, staticRenderFns } from "./DataSetShareView.vue?vue&type=template&id=0d0d5a44&scoped=true"
import script from "./DataSetShareView.vue?vue&type=script&lang=js"
export * from "./DataSetShareView.vue?vue&type=script&lang=js"
import style0 from "./DataSetShareView.vue?vue&type=style&index=0&id=0d0d5a44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0d5a44",
  null
  
)

export default component.exports